import { useState, useEffect } from 'react';
import { Avatar } from '@mui/joy';

// Аватар, который при неудачной загрузке картинки показывает инициалы (children),
// а не фрагмент URL. Полная замена обычного <Avatar src=...>.
export default function SmartAvatar({ src, children, ...props }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => { setFailed(false); }, [src]);
    return (
        <Avatar
            {...props}
            src={!failed && src ? src : undefined}
            slotProps={{ img: { onError: () => setFailed(true) } }}
        >
            {children}
        </Avatar>
    );
}